import * as React from 'react';
import { useState, useEffect } from 'react';
import {
  Stack,
  Container,
  Typography,
  Snackbar,
  Alert,
  Box,
  IconButton,
  CircularProgress
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';

//components
import Page from '../../components/Page';
import Iconify from 'src/components/Iconify';

//icons
import Scrollbar from 'src/components/Scrollbar';
import TruckProfileForm from 'src/components/MyTrucksComponents/TrucksProfileForm';
import PostDetailsForm from 'src/components/MyTrucksComponents/PostDetailsForm';
import { LoadingButton } from '@mui/lab';
import AddContactForm from 'src/components/PrivateNetworkComponents/AddContactForm';
import { api } from 'src/Api';

function PrivateNetworkForm() {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = location.state || {};

  const [profileOpen, setProfileOpen] = useState(true);
  const [postOpen, setPostOpen] = useState(true);

  const [errors, setErrors] = useState({});

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  const [isSaveLoading, setIsSaveLoading] = useState(false);
  const [loading, setloading] = useState(false);
  const [getLoading, setGetLoading] = useState(true);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    contactNumber: '',
    mcNumber: '',
    ffNumber: '',
    intrastateNumber: '',
    authority: ''
  });

  useEffect(() => {
    if (id) {
      getSelectEditData(id);
    }
  }, [id]);

  // Validation logic
  const validate = () => {
    let tempErrors = {};
    const emailRegex = /\S+@\S+\.\S+/;
    const numberRegex = /^[0-9]*$/;

    if (!formData?.name) tempErrors.name = 'Name is required.';
    if (!formData?.email) {
      tempErrors.email = 'Email is required.';
    } else if (!emailRegex.test(formData?.email)) {
      tempErrors.email = 'Valid email is required.';
    }

    if (!formData?.contactNumber) {
      tempErrors.contactNumber = 'Contact number is required.';
    } else if (!numberRegex.test(formData?.contactNumber)) {
      tempErrors.contactNumber = 'Valid contact number is required.';
    }

    if (!formData?.mcNumber) {
      tempErrors.mcNumber = 'MC Number is required.';
    } else if (!numberRegex.test(formData?.mcNumber)) {
      tempErrors.mcNumber = 'MC Number should be a valid number.';
    }

    if (!formData?.ffNumber) {
      tempErrors.ffNumber = 'FF Number is required.';
    } else if (!numberRegex.test(formData?.ffNumber)) {
      tempErrors.ffNumber = 'FF Number should be a valid number.';
    }

    if (!formData?.intrastateNumber) {
      tempErrors.intrastateNumber = 'Intrastate Number is required.';
    } else if (!numberRegex.test(formData?.intrastateNumber)) {
      tempErrors.intrastateNumber = 'Intrastate Number should be a valid number.';
    }

    if (!formData?.authority) tempErrors.authority = 'Authority is required.';

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  // Handle input change
  const handleChangevalue = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  // Handle form submission
  const handleSubmit = () => {
    if (validate()) {
      AddNewContact();
    }
  };

  //add shipment function
  function AddNewContact() {
    setIsSaveLoading(true);
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formdatas = new FormData();
    id && formdatas.append('id', id);
    formdatas.append('name', formData?.name);
    formdatas.append('email', formData?.email);
    formdatas.append('mc', formData?.mcNumber);
    formdatas.append('ff', formData?.ffNumber);
    formdatas.append('contact', formData?.contactNumber);
    formdatas.append('intrastate', formData?.intrastateNumber);
    formdatas.append('canadian', formData?.authority);

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdatas,
      redirect: 'follow'
    };

    fetch(api.save_contact, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200 || status === 201) {
          setSnackbarMessage(result.message);
          setSnackbarSeverity('success');
          setSnackbarOpen(true);
          setIsSaveLoading(false);
          setTimeout(() => {
            navigate(-1);
          }, 2000);
        } else {
          setIsSaveLoading(false);
          setSnackbarMessage(result.error);
          setSnackbarSeverity('error');
          setSnackbarOpen(true);
        }
      })
      .catch((error) => {
        setIsSaveLoading(false);
        setSnackbarMessage('An error occurred.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      });
  }

  // get group data  get_group_by_id
  const getSelectEditData = (id) => {
    setGetLoading(true);
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    const queryParams = new URLSearchParams();
    queryParams.append('id', id);

    fetch(`${api.get_contacts}?${queryParams.toString()}`, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200 || status === 201) {
          setFormData({
            name: result.data[0]?.name,
            email: result.data[0]?.email,
            contactNumber: result.data[0]?.contact,
            mcNumber: result.data[0]?.mc,
            ffNumber: result.data[0]?.ff.toString(),
            intrastateNumber: result.data[0]?.intrastate,
            authority: result.data[0]?.canadian
          });
          setGetLoading(false);
        } else {
          setFormData({
            name: '',
            email: '',
            contactNumber: '',
            mcNumber: '',
            ffNumber: '',
            intrastateNumber: '',
            authority: ''
          });
          setGetLoading(false);
        }
      })
      .catch((error) => {
        console.log('error', error);
        setGetLoading(false);
      });
  };

  // close snackbarclose funtion
  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  // open profileform funtion
  const handleProfileOpen = () => {
    setProfileOpen(!profileOpen);
  };

  return (
    <Page title={`Add Contact | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="flex-start" mb={2}>
          <IconButton
            style={{
              marginRight: 12,
              height: 40,
              width: 70,
              borderRadius: 5,
              backgroundColor: 'rgba(209,209,209,0.3)'
            }}
            onClick={() => navigate(-1)}
          >
            <Iconify icon="ion:return-up-back" style={{ fontSize: 25, color: '#010f58' }} />
          </IconButton>
          <Typography variant="h4" style={{ flex: 1, color: '#010f58' }}>
            {id ? 'Edit Contact' : 'Add Contact'}
          </Typography>
          <LoadingButton variant="contained" onClick={handleSubmit} loading={isSaveLoading}>
            {id ? 'Update' : 'Submit'}
          </LoadingButton>
        </Stack>

          <AddContactForm
            Profileopen={profileOpen}
            formData={formData}
            handleChangevalue={handleChangevalue}
            errors={errors}
            handleProfileOpen={handleProfileOpen}
            loading={getLoading && id}
          />

        <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
          <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Container>
    </Page>
  );
}

export default PrivateNetworkForm;
